import React from "react";
import { Row, Col, Tag, Flex } from "antd";
import {
  BatteryIcon,
  HumidityIcon,
  TempratureRangeIcon,
} from "../../../assets/icons/icons";
import TeamBadge from "../../../components/TeamBadge";
import { CustomParagraph } from "../../../components";
import { GoogleMapsProvider } from "../../../components/GoogleMapsProvider";
import ShipmentMap from "../ShipmentMap";

const ShipmentPreview = ({shipment}) => {



  const lastPoint = { lat: 40.7128, lng: -74.006 };

  const renderTag = (label, value, icon, style) => (
    <Tag
      icon={icon}
      style={{
        height: 20,
        borderRadius: 4,
        padding: "0 6px",
        paddingTop: 3,
        fontWeight: 600,
        ...style,
        border: "none",
      }}
    >
      {value}
    </Tag>
  );

  return (
    <Flex
      vertical
      gap={20}
      style={{
        borderRadius: "12px",
        border: "2px solid #EEE",
        padding: "30px 35px",
        cursor: "pointer",
        height: "fit-content",
      }}
    >
      <Flex align="center" gap={8}>
        <div style={{ fontWeight: 700, fontSize: 24, color: "#000" }}>
          {shipment.reference_number}
        </div>
        {/* {shipment.teams.length > 0 && (
          <Flex gap={4}>
            <TeamBadge
              color={shipment.teams[0]?.color}
              text={shipment.teams[0]?.name}
            />
          </Flex>
        )} */}
      </Flex>

      <Row justify="space-between">
        <Col>
          {/* <CustomParagraph
            text="Delivery Status"
            fontSize={12}
            fontWeight={600}
            marginBottom={0}
          /> */}
          <Tag
            color="#EAF6ED"
            style={{
              color: "#0E8345",
              fontSize: "10px",
              fontWeight: 600,
              borderRadius: 8,
            }}
          >
            {shipment.delivery_status}
          </Tag>
        </Col>
        <Col>
          <CustomParagraph
            text="ZoomLogi ETA"
            marginBottom={0}
            fontSize={12}
            fontWeight={600}
          />
          <CustomParagraph
            text={shipment.estimated_delivery_date}
            fontSize={12}
          />
        </Col>
      </Row>

      <GoogleMapsProvider>
        <ShipmentMap
          currentView="summary"
          lastCoordinates={lastPoint}
          shipment={shipment}
          height={"240px"}
          isLargeScreen={false}
        />
      </GoogleMapsProvider>

      <Flex justify="space-between" align="center" style={{ marginBottom: 8 }}>
        <div style={{ fontWeight: 700, fontSize: 18, color: "#000" }}>
          Shipment details
        </div>
        <Flex gap={12} wrap>
          {renderTag(
            "Temperature",
            shipment.monitor_info.temperature,
            <TempratureRangeIcon />,
            {
              backgroundColor: "#F3F3F3",
              color: "#757575",
            }
          )}
          {renderTag(
            "Battery",
            shipment.monitor_info.battery,
            <BatteryIcon />,
            {
              backgroundColor: "#F3F3F3",
              color: "#757575",
            }
          )}
          {renderTag(
            "Humidity",
            shipment.monitor_info.humidity,
            <HumidityIcon />,
            {
              backgroundColor: "#F3F3F3",
              color: "#757575",
            }
          )}
        </Flex>
      </Flex>

      <Row justify="space-between">
        <Col span={11}>
          <CustomParagraph
            text="Origin"
            fontSize={12}
            fontWeight={600}
            marginBottom={0}
          />
          <CustomParagraph
            text={shipment?.from_location?.name}
            fontSize={12}
            marginBottom={0}
          />
        </Col>
        <Col span={11}>
          <CustomParagraph
            text="Destination"
            fontSize={12}
            fontWeight={600}
            marginBottom={0}
          />
          <CustomParagraph
            text={shipment?.to_location?.name}
            fontSize={12}
            marginBottom={0}
          />
        </Col>
      </Row>

      <Row justify="space-between">
        <Col span={11}>
          <CustomParagraph
            text="Pickup Date"
            fontSize={12}
            fontWeight={600}
            marginBottom={0}
          />
          <CustomParagraph
            text={shipment.scheduled_pickup_date}
            fontSize={12}
            marginBottom={0}
          />
        </Col>
        <Col span={11}>
          <CustomParagraph
            text="Delivery Date"
            fontSize={12}
            fontWeight={600}
            marginBottom={0}
          />
          <CustomParagraph
            text={shipment.scheduled_delivery_date}
            fontSize={12}
            marginBottom={0}
          />
        </Col>
      </Row>

      <Row justify="space-between">
        <Col span={11}>
          <CustomParagraph
            text="Weight (kg)"
            fontSize={12}
            fontWeight={600}
            marginBottom={0}
          />
          <CustomParagraph
            text={shipment.weight_kg}
            fontSize={12}
            marginBottom={0}
          />
        </Col>
        <Col span={11}>
          <CustomParagraph
            text="Dimensions"
            fontSize={12}
            fontWeight={600}
            marginBottom={0}
          />
          <CustomParagraph
            text={shipment.volume}
            fontSize={12}
            marginBottom={0}
          />
        </Col>
      </Row>

      <Row justify="space-between">
        <Col span={11}>
          <CustomParagraph
            text="Product Name"
            fontSize={12}
            fontWeight={600}
            marginBottom={0}
          />
          <CustomParagraph
            text={shipment.product.name}
            fontSize={12}
            marginBottom={0}
          />
        </Col>
        <Col span={11}>
          <CustomParagraph
            text="Product Type"
            fontSize={12}
            fontWeight={600}
            marginBottom={0}
          />
          <CustomParagraph
            text={shipment.product.product_type}
            fontSize={12}
            marginBottom={0}
          />
        </Col>
      </Row>

      <Row justify="space-between">
        <Col span={11}>
          <CustomParagraph
            text="Sensor Type"
            fontSize={12}
            fontWeight={600}
            marginBottom={0}
          />
          <CustomParagraph
            text={shipment.sensor.type}
            fontSize={12}
            marginBottom={0}
          />
        </Col>
        <Col span={11}>
          <CustomParagraph
            text="Sensor ID"
            fontSize={12}
            fontWeight={600}
            marginBottom={0}
          />
          <CustomParagraph
            text={shipment.sensor.id}
            fontSize={12}
            marginBottom={0}
          />
        </Col>
      </Row>

      <Row justify="space-between">
        <Col span={11}>
          <CustomParagraph
            text="Courier"
            fontSize={12}
            fontWeight={600}
            marginBottom={0}
          />
          <CustomParagraph
            text={shipment.courier.title}
            fontSize={12}
            marginBottom={0}
          />
        </Col>
        <Col span={11}>
          <CustomParagraph
            text="Phone"
            fontSize={12}
            fontWeight={600}
            marginBottom={0}
          />
          <CustomParagraph
            text={shipment.contact_phone}
            fontSize={12}
            marginBottom={0}
          />
        </Col>
      </Row>

      <Row justify="space-between">
        <Col span={11}>
          <CustomParagraph
            text="Tracking ID"
            fontSize={12}
            fontWeight={600}
            marginBottom={0}
          />
          <CustomParagraph
            text={shipment.courier_tracking_id}
            fontSize={12}
            marginBottom={0}
          />
        </Col>
        <Col span={11}>
          <CustomParagraph
            text="ETA"
            fontSize={12}
            fontWeight={600}
            marginBottom={0}
          />
          <CustomParagraph
            text={shipment.transport_provider_eta}
            fontSize={12}
            marginBottom={0}
          />
        </Col>
      </Row>
    </Flex>
  );
};

export default ShipmentPreview;
